
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/companies/[organizationId]/membership/new",
      function () {
        return require("private-next-pages/admin/companies/[organizationId]/membership/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/companies/[organizationId]/membership/new"])
      });
    }
  